import { Skeleton, SkeletonCards, SkeletonText } from '../components/ui/skeleton';

/** Shown while a lazily loaded page's chunk downloads. */
export function PageFallback() {
  return (
    <div className="mx-auto max-w-6xl p-6 space-y-6" role="status" aria-live="polite">
      <span className="sr-only">Loading page…</span>
      <Skeleton className="h-8 w-1/3" />
      <SkeletonText lines={2} />
      <SkeletonCards count={3} />
    </div>
  );
}
